// ═══════════════════════════════════════════════════════════════════
// TMS GAMMA — Cliente Supabase
// src/lib/supabaseClient.js
// ═══════════════════════════════════════════════════════════════════
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL  = "https://kotroujukcmiygevbxea.supabase.co";
const SUPABASE_ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtvdHJvdWp1a2NtaXlnZXZieGVhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEwMTI4NjMsImV4cCI6MjA5NjU4ODg2M30.n39XMOZEFoQQjiGth0HbBJYYsA918stWjxTkJ_CBYIM";

// IMPORTANTE: não configurar "auth.lock" aqui.
// Nesta versão do auth-js (2.108) o padrão já é SEM lock — o próprio código
// diz "this.lock stays null when no custom lock is supplied (lockless path)".
// Fornecer um lock customizado LIGA uma fila que não existia: se qualquer
// operação de auth não resolver, ela envenena a fila e todas as chamadas
// seguintes ficam penduradas (login preso em "Aguarde..." para sempre).
let supabaseInstance;
try {
  supabaseInstance = createClient(SUPABASE_URL, SUPABASE_ANON, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  });
} catch(e) {
  console.error("Erro ao inicializar Supabase:", e);
  // Fallback mock para evitar crash total
  supabaseInstance = {
    auth: {
      getSession:          () => Promise.resolve({ data: { session: null } }),
      onAuthStateChange:   (cb) => { return { data: { subscription: { unsubscribe: ()=>{} } } }; },
      signInWithPassword:  () => Promise.resolve({ error: { message: "Supabase offline" } }),
      signOut:             () => Promise.resolve({}),
    },
    from: () => ({
      select: () => ({ order: () => ({ limit: () => Promise.resolve({ data: [], error: null }) }), data: [], error: null }),
      upsert: () => Promise.resolve({ error: null }),
      insert: () => Promise.resolve({ error: null }),
    }),
  };
}

export const supabase = supabaseInstance;
